import PreparationCard from "../../../../../ReusableComponent/PreparationCards";
const PreparationTracks = () => {
  // Array of preparation tracks
  const tracks = [
    {
      title: "Software Engineer",
      description: "Full-stack development preparation",
      duration: "12 weeks",
      questions: "1200 enrolled",
      subjects: ["Data Structures", "Algorithms", "System Design", "Coding"],
      difficulty: "Medium",
      buttonLabel: "Start Preparation",
    },
    {
      title: "Data Scientist",
      description: "Data science and ML preparation",
      duration: "10 weeks",
      questions: "850 enrolled",
      subjects: ["Statistics", "ML Algorithms", "Python", "SQL"],
      difficulty: "Hard",
      buttonLabel: "Start Preparation",
    },
    {
      title: "Frontend Developer",
      description: "Frontend specialization track",
      duration: "8 weeks",
      questions: "950 enrolled",
      subjects: ["React", "JavaScript", "CSS", "UI/UX"],
      difficulty: "Easy",
      buttonLabel: "Start Preparation",
    },
  ];

  return (
    <section className="row mx-0 py-5 my-5 d-flex justify-content-center align-items-center">
      <div className="col-md-11 col-12">
        <div className="row mx-0 d-flex justify-content-center align-items-center">
          <div className="col-md-10 text-center mb-5">
            <h2 className="fw-bold text-light">
              Choose Your Preparation Track
            </h2>
          </div>
          <div className="row mx-0 d-flex justify-content-center">
            {tracks.map((track, index) => (
              <PreparationCard key={index} {...track} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreparationTracks;
